import { Suspense, lazy } from "react";
import type { TabularResultRow } from "../resultTypes";

interface LazyRelationalResultGridProps {
  rows: TabularResultRow[];
}

const RelationalResultGrid = lazy(async () => {
  const module = await import("./RelationalResultGrid");
  return { default: module.RelationalResultGrid };
});

export function LazyRelationalResultGrid({ rows }: LazyRelationalResultGridProps) {
  return (
    <Suspense
      fallback={(
        <div className="flex flex-1 items-center justify-center text-sm text-zinc-500">
          Loading table view...
        </div>
      )}
    >
      <RelationalResultGrid rows={rows} />
    </Suspense>
  );
}
